import { DepthRow } from "@/ui/wx";
import type { SpotBookLevel } from "@/api/market";
import { fmtAmount, fmtSpotPrice } from "@/lib/format";

function fmtQty(v: unknown): string {
  return fmtAmount(v);
}

function maxQty(levels: SpotBookLevel[]): number {
  let m = 0;
  for (const lv of levels) {
    const q = Number(lv.qty ?? lv.amount ?? 0);
    if (Number.isFinite(q) && q > m) m = q;
  }
  return m || 1;
}

export function OrderBook({
  asks,
  bids,
  last,
  pair,
}: {
  asks: SpotBookLevel[];
  bids: SpotBookLevel[];
  last?: string;
  pair?: string;
}) {
  const a = asks.slice(0, 8).reverse();
  const b = bids.slice(0, 8);
  const maxA = maxQty(a);
  const maxB = maxQty(b);

  return (
    <div className="wx-book" dir="ltr">
      <div className="wx-book-head">
        <span>Price</span>
        <span>Amount</span>
      </div>
      <div className="wx-book-asks">
        {a.map((lv, i) => (
          <DepthRow
            key={`a${i}`}
            side="ask"
            price={fmtSpotPrice(lv.price, pair)}
            qty={fmtQty(lv.qty ?? lv.amount)}
            depthPct={(Number(lv.qty ?? lv.amount ?? 0) / maxA) * 100}
          />
        ))}
        {!a.length && <p className="wx-empty">—</p>}
      </div>
      <div className="wx-book-mid">{last && last !== "—" ? last : "—"}</div>
      <div className="wx-book-bids">
        {b.map((lv, i) => (
          <DepthRow
            key={`b${i}`}
            side="bid"
            price={fmtSpotPrice(lv.price, pair)}
            qty={fmtQty(lv.qty ?? lv.amount)}
            depthPct={(Number(lv.qty ?? lv.amount ?? 0) / maxB) * 100}
          />
        ))}
        {!b.length && <p className="wx-empty">—</p>}
      </div>
    </div>
  );
}
